import { render, staticRenderFns } from "./toolsQsdaToHandicap.vue?vue&type=template&id=3038746e&scoped=true"
import script from "./toolsQsdaToHandicap.vue?vue&type=script&lang=js"
export * from "./toolsQsdaToHandicap.vue?vue&type=script&lang=js"
import style0 from "./toolsQsdaToHandicap.vue?vue&type=style&index=0&id=3038746e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3038746e",
  null
  
)

export default component.exports